import updateText from './update-text';

export default function(node, data) {
  if (!node) {
    return;
  }

  // show the h, d or away odds if they are present
  if (data && data.hasOwnProperty('markets')) {
    node.setAttribute('data-show-odds', true);
    node.setAttribute('data-active', data.active);

    node.querySelectorAll('[data-update="odds"]').forEach((item, index) => {
      const selection = data.markets[0].selections[index];
      item.setAttribute('data-active', Boolean(selection.active));
      updateText(item, selection.price);
    });
  } else {
    node.setAttribute('data-show-odds', false);
  }
}
